import { createAction } from '@reduxjs/toolkit';
import {
  SHOW_MODAL,
  HIDE_MODAL,
  MODAL_CONFIRMED,
  ModalContent,
} from './modalModel';

export const showModal = createAction(SHOW_MODAL, (content: ModalContent) => ({
  payload: content,
}));

export const hideModal = createAction(HIDE_MODAL);

export const modalConfirmed = createAction(MODAL_CONFIRMED);
